











import { LWMSTileLayer, LLayerGroup } from "vue2-leaflet";
import { CRS } from "leaflet";
import urls from "../../../web_client/urls";

export default {
  name: "MarineLayer",
  components: {
    "l-wms-tile-layer": LWMSTileLayer,
    LLayerGroup,
  },
  data: () => ({
    layer: {
      format: "image/png",
      layer: "SeaChart_DAY_BRIGHT",
      id: "day_bright",
      url: urls.mapsUrls.marine,
      crs: CRS.EPSG4326,
    },
  }),
};
